import DayJsUtil from './DayJSUtils';
import Strings from '../constants/Strings';
import { chain, reduce, isArray, isEmpty, keyBy, groupBy } from 'lodash';
import { ITEM_ADD_HOPE, ITEM_CARRY_BAG } from '../constants';
const SPECIAL_ITEMS = [ITEM_ADD_HOPE, ITEM_CARRY_BAG];
export class MenuUtils {
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    static filterCatalogByExclusionAndAvailability(menuResponse, exclusionResponse = [], scheduledDateTime = {}, inUtc = false) {
        const response = exclusionResponse?.[0] ?? [];
        const excludedMenuItems = groupBy(response, 'entityType');
        const { category: categoryExclusion = [], item = [], product: productExclusion = [] } = excludedMenuItems;
        const isEntityAvailable = response?.[0]?.entityType;
        const itemExclusion = isEntityAvailable ? item : response;
        const currentTime = DayJsUtil.setUnix(DayJsUtil.dayjs());
        const { time = currentTime } = scheduledDateTime ?? {};
        const scheduledTime = time >= currentTime ? time : currentTime;
        const scheduledTimeObj = DayJsUtil.getUnix(scheduledTime, inUtc);
        const scheduledTimeValue = Number.parseInt(DayJsUtil.formatValue(scheduledTimeObj, Strings.dateTimeFormatHHmm));
        const scheduledAvailabilityDaysOfWeek = [
            Strings.everyDay,
            DayJsUtil.formatValue(scheduledTimeObj, Strings.momentWeekDay).toLowerCase(),
        ];
        const filteredMenu = menuResponse;
        const menuCategories = filteredMenu?.categories?.filter((category) => category?.name === Strings.menu || category?.name === Strings.cateringCatalogType);
        if (!isArray(menuCategories)) {
            return filteredMenu;
        }
        const [{ categories }] = menuCategories;
        const filteredCategories = MenuUtils.filterExcludedAndUnavailableItems(categories, categoryExclusion, scheduledTime, scheduledAvailabilityDaysOfWeek, scheduledTimeValue);
        menuCategories[0].categories = filteredCategories?.map((category) => {
            const products = MenuUtils.filterExcludedAndUnavailableItems(category.products, productExclusion, scheduledTime, scheduledAvailabilityDaysOfWeek, scheduledTimeValue);
            category.products = products?.filter((product) => {
                const items = product.items;
                product.items = MenuUtils.filterExcludedAndUnavailableItems(items, itemExclusion, scheduledTime, scheduledAvailabilityDaysOfWeek, scheduledTimeValue);
                return !isEmpty(product?.items);
            });
            return category;
        });
        return filteredMenu;
    }
    static filterExcludedAndUnavailableItems(items, excludedMenuItems, scheduledTime, scheduledAvailabilityDaysOfWeek, scheduledTimeValue) {
        return items?.filter((item) => {
            let nonAvailabilityCode;
            const itemExcluded = excludedMenuItems?.find((excludedItem) => {
                if (excludedItem.itemId === item.id) {
                    nonAvailabilityCode = excludedItem?.nonAvailabilityCode;
                }
                return (excludedItem.itemId === item.id &&
                    scheduledTime >= excludedItem?.startDateInEpoch &&
                    scheduledTime <= excludedItem?.endDateInEpoch);
            });
            if (!itemExcluded) {
                item['isNotAvailable'] = false;
                if (isEmpty(item.availability)) {
                    return true;
                }
                const itemAvailableAtScheduledTime = MenuUtils.filterByAvailability(item, scheduledAvailabilityDaysOfWeek, scheduledTimeValue);
                // if (!itemAvailableAtScheduledTime) {
                //   console.log(`=============item not available: ${item.id}`);
                // }
                return !!itemAvailableAtScheduledTime;
            }
            if (itemExcluded && nonAvailabilityCode === 'NA') {
                item['isNotAvailable'] = true;
                return true;
            }
            // console.log(`=============item excluded: ${item.id}`);
            return false;
        });
    }
    static clearMasterList(catalogName = '') {
        MenuUtils.master = {
            catalogName: catalogName,
            categories: [],
            categoryMapByUrl: {},
            categoryMapById: {},
            products: [],
            productMapById: {},
            productMapByUrl: {},
            items: [],
            itemMapById: {},
            itemMapByUrl: {},
            productMapByItemId: {},
            productMapByProductUrl: {},
            specialItemMapByName: {},
            modgrps: [],
            modifiers: [],
        };
    }
    static getAllProductsFromCategories(categories) {
        return reduce(categories, (products, category) => [...products, ...category.products], []);
    }
    static getProductMapBy(products, by = 'url') {
        return keyBy(products, (product) => product.items?.[0]?.[by] ?? 'NA');
    }
    static addToMapIfNotExists(map, key, value) {
        if (!Object.keys(map).includes(key)) {
            map[key] = value;
        }
    }
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    static createFlatList(obj) {
        MenuUtils.flattenCategories(obj);
        MenuUtils.flattenProducts(obj);
        MenuUtils.flattenItems(obj);
        MenuUtils.flattenModGroups(obj);
        MenuUtils.flattenModifiers(obj);
        return MenuUtils.master;
    }
    static flattenCategories(obj) {
        const categories = obj?.categories;
        if (categories) {
            for (let index = 0; index < categories.length; index++) {
                const category = categories[index];
                category.parentID = obj.id;
                category.type = 'category';
                category.path = obj.path ? `${obj.path}.categories[${index}]` : `categories[${index}]`;
                MenuUtils.master.categories.push(category);
                MenuUtils.addToMapIfNotExists(MenuUtils.master.categoryMapById, category.id, category);
                MenuUtils.addToMapIfNotExists(MenuUtils.master.categoryMapByUrl, category.url, category);
                MenuUtils.createFlatList(category);
            }
        }
        obj.categories = undefined;
    }
    static flattenProducts(obj) {
        const products = obj?.products;
        if (products) {
            for (let index = 0; index < products.length; index++) {
                const product = products[index];
                product.parentID = obj?.id;
                product.categoryId = obj?.id;
                product.categoryName = obj?.name;
                product.type = 'product';
                product.path = `${obj?.path}.products[${index}]`;
                product.url = product.url || product?.items?.[0]?.url;
                product.imageObj = product?.items?.[0]?.imageName;
                product.additionalPropertyMap = {};
                MenuUtils.master.products.push(product);
                MenuUtils.createFlatList(product);
            }
            obj.productMapByProductUrl = keyBy(products, 'url');
        }
        obj.products = undefined;
    }
    static flattenItems(obj) {
        const items = obj?.items;
        if (items) {
            for (let index = 0; index < items.length; index++) {
                const item = items[index];
                item.parentID = obj.id;
                item.categoryId = obj?.categoryId;
                item.categoryName = obj?.categoryName;
                item.type = 'item';
                item.path = `${obj?.path}.items[${index}]`;
                item.additionalPropertyMap = chain(item?.additionalProperties)
                    .keyBy('key')
                    .mapValues((p) => p.value?.toLowerCase())
                    .value();
                obj.additionalPropertyMap = { ...obj.additionalPropertyMap, ...item.additionalPropertyMap };
                MenuUtils.master.items.push(item);
                MenuUtils.addToMapIfNotExists(MenuUtils.master.itemMapById, item.id, item);
                MenuUtils.addToMapIfNotExists(MenuUtils.master.itemMapByUrl, item.url, item);
                MenuUtils.addToMapIfNotExists(MenuUtils.master.productMapByItemId, item.id, obj);
                //creating product maps with first item in the items array
                if (index === 0) {
                    MenuUtils.addToMapIfNotExists(MenuUtils.master.productMapById, item.id, obj);
                    MenuUtils.addToMapIfNotExists(MenuUtils.master.productMapByUrl, item.url, obj);
                    MenuUtils.addToMapIfNotExists(MenuUtils.master.productMapByProductUrl, obj.url, obj);
                }
                if (SPECIAL_ITEMS.includes(item.name)) {
                    MenuUtils.master.specialItemMapByName[item.name] = item;
                }
                MenuUtils.createFlatList(item);
            }
            obj.itemMapByItemUrl = keyBy(items, 'url');
            obj.itemMapByItemId = keyBy(items, 'id');
        }
        obj.items = undefined;
    }
    static flattenModGroups(obj) {
        const modGroups = obj?.modgrps;
        if (modGroups) {
            for (let index = 0; index < modGroups.length; index++) {
                const modGroup = modGroups[index];
                modGroup.type = 'modGroup';
                modGroup.parentID = obj.id;
                modGroup.toggleOpen = index === 0;
                modGroup.isUpdated = false;
                modGroup.path = obj.path ? `${obj.path}.modgrps[${index}]` : `modgrps[${index}]`;
                MenuUtils.master.modgrps.push(modGroup);
                MenuUtils.createFlatList(modGroup);
            }
        }
        obj.modgrps = undefined;
    }
    static flattenModifiers(obj) {
        const modifiers = obj?.modifiers;
        if (modifiers) {
            for (let index = 0; index < modifiers.length; index++) {
                const modifier = modifiers[index];
                modifier.parentID = obj.id;
                modifier.type = 'modifier';
                modifier.checked = !!modifier.isDefault;
                modifier.path = obj.path ? `${obj.path}.modifiers[${index}]` : `modifiers[${index}]`;
                MenuUtils.master.modifiers.push(modifier);
                MenuUtils.createFlatList(modifier);
            }
        }
        obj.modifiers = undefined;
    }
    static filterByAvailability(item, scheduledAvailabilityDaysOfWeek, scheduledTimeValue) {
        return item.availability?.find((availability) => {
            const itemAvailabilityDayOfWeek = availability?.dayOfWeek?.day?.toLowerCase();
            if (scheduledAvailabilityDaysOfWeek.includes(itemAvailabilityDayOfWeek)) {
                const startTime = availability?.availableHours?.startTime?.time ?? '-1';
                const endTime = availability?.availableHours?.endTime?.time ?? '99999';
                if (startTime?.length !== 4 && endTime?.length !== 4) {
                    return true;
                }
                return scheduledTimeValue >= parseInt(startTime) && scheduledTimeValue <= parseInt(endTime);
            }
            return false;
        });
    }
}
MenuUtils.master = {
    catalogName: '',
    categories: [],
    categoryMapByUrl: {},
    categoryMapById: {},
    products: [],
    productMapById: {},
    productMapByUrl: {},
    items: [],
    itemMapById: {},
    itemMapByUrl: {},
    productMapByItemId: {},
    productMapByProductUrl: {},
    specialItemMapByName: {},
    modgrps: [],
    modifiers: [],
};
